export default "__VITE_PUBLIC_ASSET__d6463441__"